import { render, staticRenderFns } from "./TeamsTypes.vue?vue&type=template&id=c0344372&"
import script from "./TeamsTypes.vue?vue&type=script&lang=js&"
export * from "./TeamsTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports